var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-2 2.5a.75.75 0 0 1 .75-.75H8a.75.75 0 0 1 .75.75v5.25H10a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25v-4.5H6.5A.75.75 0 0 1 5.75 7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;